<a class="br-link-1 flex layout-row"
   #stateLink
   (click)="onClick($event)"
   (contextmenu)="$event.stopPropagation()"
   href="{{$state.href(state, params)}}">
  <span class="flex text-ellipsis" *ngIf="text">{{ text }}</span>
  <ng-content class="flex text-ellipsis"></ng-content>
</a>
